module.exports = __webpack_public_path__ + "assets/img/folder.5c29c576.svg";